module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"date":"Date","asap":"asap.","cancel":"Cancel","ok":"OK","today":"Today"},"de":{"date":"Datum","asap":"sofort","cancel":"Abbrechen","ok":"OK","today":"Heute"}}')
  delete Component.options._Ctor
}
